<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Link To Recipient EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2 fieldName">
            In EMR
          </div>
          <div class="col-2 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recipientID"
              disabled
              label="Recipient ID"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recipientIDOATS"
              disabled
              label="Recipient ID"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="donorRelationship"
              disabled
              label="Donor Relationship"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="donorRelationshipOATS"
              disabled
              label="Donor Relationship"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>
  
  <script>
  import _ from 'lodash';
  
  const RELATIONSHIP_CODE_TO_TEXT = {
    '1': 'PARENT',
    '10': 'EXECUTOR',
    '2': 'SIBLING',
    '3': 'CHILD',
    '4': 'AUNT/UNCLE',
    '5': 'OTHER RELATIVE',
    '6': 'UNRELATED',
    '7': 'SPOUSAL',
    '8': 'COUSIN',
    '9': 'NOT DOCUMENTED',
  };
  
  export default {
    name: "LinkToRecipientSectionEMROATS",
    props: {
      patient: {
        type: Object,
        default: null,
      },
      patientBundle: {
        type: Object,
        default: null,
      },
      patientBundleOATS: {
        type: Object,
        default: null,
      }
    },
    data() {
      return {
        donorRelationship: this.getDonorRelationship( this.patientBundle ),
        recipientID: this.getRecipientID( this.patientBundle ),
        recipientIDOATS: this.getRecipientIDOATS( this.patientBundleOATS ),
        donorRelationshipOATS: this.getDonorRelationshipOATS( this.patientBundleOATS ),
      };
      },
     mounted() {
      
      },
    methods: {
      combineProps() {
        return `${this.patient}`;
      }, 
      getDonorRelationship( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let donorRelationship = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#404' ) ) ;
      if( donorRelationship && donorRelationship[ 0 ] ) {
        return _.get( donorRelationship[0], 'resource.component[0].valueString' );   
      } 
      }
      },
      getRecipientID( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let id = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#403' ) );
        if ( id && id[0] ) {
          return _.get( id[0], 'resource.component[0].valueString' );
        }
      }
      },
      getRecipientIDOATS( patientBundleOATS ) {
        return patientBundleOATS?.living_donor_info?.journeys[0]?.intended_recipients[0]?.recipient.client_id;
      },
      getDonorRelationshipOATS( patientBundleOATS ) {
        const code = patientBundleOATS?.living_donor_info?.journeys[0]?.intended_recipients[0]?.donor_relationship_code;
        if ( code === null || code === undefined || code === '' ) return undefined;
        const normalized = String( code );
        return RELATIONSHIP_CODE_TO_TEXT[normalized] ?? normalized;
      },
    },
  };
  </script>
  
  <style scoped>
  
  /* .card {
    height: 340px;
  } */
  
  .sectionHeading {
    background-color: rgb(59, 53, 53);
    color: white;
    padding-left: 5px;
  }
  .page-content .summary-card .card-header .summary-name {
    padding-left: 35px;
    padding-top: 4px;
    font-weight: 300;
  }
  
  .sections {
    font-size: 15px;
    height: 280px;
    width: 1400px;
    /* overflow: scroll; */
    padding-left: 10px;
    /* padding-top: 5px; */
  }
  
  .inputDisplay {
  border-style: solid;
  background-color: #F2F2F2;
  }
  
  .fieldName {
    font-weight: 700;
    font-size: 0.875rem;
    /* padding-top: 5.5px; */
    /* padding-bottom: 2.5px; */
    /* padding-right: 15px; */
    padding-inline-start: 2%;
  }
  
  :deep(.afflo-ds-form-control) {
    width: max-content;
  }
  
  :deep(label) {
    width: max-content;
  }
  
  :deep(.ExceptionalDistributionReasonOther .afflo-ds-form-control) {
    width: 400px;
  }
  
  </style>
  